import { useEffect, useState, useMemo, useRef } from 'react'
import {
  Form,
  Input,
  Select,
  Checkbox,
  Radio,
  Button,
  Tooltip,
  Switch,
  InputNumber,
  Space,
  DatePicker,
  Cascader,
  TimePicker,
  TreeSelect,
  Badge,
} from 'antd'
import { SvgIcon, BasSwitch } from '@/components'
import styled from 'styled-components'
import moment from 'moment'
import { useTaskGroup, useGetProxy, useGetSecurityDevice, useGetEncTypeList } from './utils'
import { useGetTaskBaseInfo } from '../task-list/utils'
import { disabledDate, disabledDateTime } from '@/utils/appointment'
import type { DefaultOptionType } from 'antd/es/cascader'
import { useNavigate, useLocation } from 'react-router-dom'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { t } from '@/i18n'

interface SecurityDevice {
  deviceId: string
  deviceName: string
  deviceIp: string
  deviceStatus: string
  chainId: string
}

interface SecurityDeviceType {
  deviceType: string
  devices: SecurityDevice[]
}

interface WAFCreateConfigProps {
  submitForm: (values: any) => void
  createForm: any
  initialValues?: any
  areaData: any
  templateState?: {
    selectedTemplateIds: string[]
    selectedCaseIds: string[]
    executeTemplateLatestCase: boolean
    selectedTemplateId?: string
    templateSwitchStates: Record<string, boolean>
  }
  onTemplateStateChange?: (newState: {
    selectedTemplateIds?: string[]
    selectedCaseIds?: string[]
    executeTemplateLatestCase?: boolean
    selectedTemplateId?: string
    templateSwitchStates: Record<string, boolean>
  }) => void
}

export const WAFCreateConfig = ({
  submitForm,
  createForm,
  initialValues,
  areaData,
  templateState,
  onTemplateStateChange,
}: WAFCreateConfigProps) => {
  const navigate = useNavigate()
  const { state: stateParams } = useLocation() as { state: { id?: string } }
  const [taskGroup, getTaskGroup] = useTaskGroup()
  const [proxyData, getProxy] = useGetProxy()
  const [getSecurityDevice] = useGetSecurityDevice()
  const [getTaskBaseInfo, taskBaseInfo] = useGetTaskBaseInfo()
  const [securityDeviceData, setSecurityDeviceData] = useState<SecurityDeviceType[]>([])
  const [enTypeList, getEncTypeList] = useGetEncTypeList()
  const [selectedChainId, setSelectedChainId] = useState<string | null>(null)
  const [monthList, setMonthList] = useState<{ title: string; value: number }[]>([])
  console.log('initialValues1111111111111111', initialValues)

  // 合并状态管理
  const [formState, setFormState] = useState({
    verifyMode: initialValues?.verification_mode_id || [2],
    executeType: initialValues?.execute_type || 1,
    executeTimes: initialValues?.execute_times || 1,
    taskTime: initialValues?.task_time
      ? moment.isMoment(initialValues.task_time)
        ? initialValues.task_time
        : moment(initialValues.task_time, 'HH:mm:ss')
      : undefined,
    encode: initialValues?.encode || false,
    schedulerType: initialValues?.scheduler_type || 'scheduler_type_daily',
    executeTimesLimit: initialValues?.execution_times || 0,
    dayOfWeek: initialValues?.day_of_week || [],
    dayOfMonth: initialValues?.day_of_month || [],
    executeTemplateLatestCase: initialValues?.execute_template_latest_case ?? true,
    webAppCount: 0,
    reduceSpeed: initialValues?.reduce_speed || 20,
    priority: initialValues?.priority || 3,
    poolId: initialValues?.pool_id,
    executionCycle: initialValues?.execution_cycle || false,
  })

  // 使用 useRef 来跟踪是否已经初始化
  const isInitialized = useRef(false)
  const taskTimeRef = useRef<moment.Moment | undefined>(formState.taskTime)
  const taskTimeMomentRef = useRef<moment.Moment | undefined>(formState.taskTime)
  const initialTaskTimeRef = useRef<moment.Moment | undefined>(formState.taskTime)
  const isTimeInitialized = useRef(false)
  const isTimeUpdating = useRef(false)

  // 初始化 taskTimeMomentRef
  useEffect(() => {
    if (initialValues?.task_time && !isTimeInitialized.current) {
      let momentTime: moment.Moment | undefined
      if (moment.isMoment(initialValues.task_time)) {
        momentTime = initialValues.task_time
      } else if (typeof initialValues.task_time === 'string') {
        momentTime = moment(initialValues.task_time, 'HH:mm:ss')
      }
      if (momentTime && momentTime.isValid()) {
        taskTimeMomentRef.current = momentTime
        taskTimeRef.current = momentTime
        initialTaskTimeRef.current = momentTime
        isTimeInitialized.current = true
        setFormState(prev => ({ ...prev, taskTime: momentTime }))
        console.log('Initialized time from initialValues:', momentTime.format('HH:mm:ss'))
      }
    }
  }, [initialValues?.task_time])

  // 更新 taskTimeRef 当 taskTime 变化时
  useEffect(() => {
    if (
      formState.taskTime &&
      (!taskTimeRef.current || !formState.taskTime.isSame(taskTimeRef.current)) &&
      !isTimeUpdating.current
    ) {
      if (formState.taskTime.isValid()) {
        taskTimeRef.current = formState.taskTime
        taskTimeMomentRef.current = formState.taskTime
        console.log('Updated time from formState:', formState.taskTime.format('HH:mm:ss'))
      }
    }
  }, [formState.taskTime])

  console.log('stateParams', stateParams)

  useEffect(() => {
    if (stateParams?.id && !isInitialized.current) {
      isInitialized.current = true
      getTaskBaseInfo(stateParams.id)
        .then(res => {
          console.log('res', res)
          // 复制任务时默认选择即时任务
          const type = 1

          console.log('Final taskTime:', undefined)

          // 复制任务时，重置为即时任务，不需要设置时间
          setFormState(prev => ({
            ...prev,
            executeType: type,
            schedulerType: 'scheduler_type_daily',
            taskTime: undefined,
            executeTimesLimit: 0,
            dayOfWeek: [],
            dayOfMonth: [],
            executionCycle: false,
          }))

          // 设置表单值（复制任务时默认选择即时任务）
          const formValues = {
            name: res.data.name,
            business_site_id: res.data.siteId,
            encode: res.data.encode === 'EncodeDynamic',
            proxy_pool_id: res.data.poolId === '0' ? undefined : res.data.poolId,
            group_id: res.data.groupId,
            execute_type: type,
            scheduler_type: 'scheduler_type_daily',
            task_time: undefined,
            execution_times: 0,
            day_of_week: [],
            day_of_month: [],
            execution_cycle: false,
          }

          console.log('Setting form values for copied task (default to immediate)')

          // 确保所有值都设置后再调用 setFieldsValue
          createForm.setFieldsValue(formValues)
        })
        .catch(_ => {})
    }
  }, [stateParams?.id])

  // 监听 initialValues 变化
  useEffect(() => {
    if (initialValues && !isInitialized.current) {
      console.log('initialValues-----------3333', initialValues)

      let taskTimeMoment: moment.Moment | undefined
      if (initialValues.task_time) {
        if (typeof initialValues.task_time === 'string') {
          taskTimeMoment = moment(initialValues.task_time, 'HH:mm:ss')
        } else if (moment.isMoment(initialValues.task_time)) {
          taskTimeMoment = initialValues.task_time
        }
      }

      // 如果已经有初始时间值，则使用它
      if (initialTaskTimeRef.current) {
        taskTimeMoment = initialTaskTimeRef.current
      }

      console.log('taskTime in initialValues', taskTimeMoment)

      // 更新 formState
      setFormState(prev => ({
        ...prev,
        ...initialValues,
        verifyMode: initialValues.verification_mode_id || prev.verifyMode,
        executeType: initialValues.execute_type || prev.executeType,
        executeTimes: initialValues.execute_times || prev.executeTimes,
        taskTime: taskTimeMoment || prev.taskTime,
        encode: initialValues.encode,
        schedulerType: initialValues.scheduler_type || prev.schedulerType,
        executeTimesLimit: initialValues.execution_times || prev.executeTimesLimit,
        dayOfWeek: initialValues.day_of_week || prev.dayOfWeek,
        dayOfMonth: initialValues.day_of_month || prev.dayOfMonth,
        executeTemplateLatestCase:
          initialValues.execute_template_latest_case ?? prev.executeTemplateLatestCase,
        reduceSpeed: initialValues.reduce_speed || prev.reduceSpeed,
        priority: initialValues.priority || prev.priority || 3,
        poolId: initialValues.pool_id || prev.poolId,
      }))

      // 设置表单值
      const formValues = {
        ...initialValues,
        task_time: taskTimeMoment,
        execution_times: initialValues.execution_times || 0,
        day_of_week: initialValues.day_of_week || [],
        day_of_month: initialValues.day_of_month || [],
      }

      // 确保所有值都设置后再调用 setFieldsValue
      createForm.setFieldsValue(formValues)
    }
  }, [initialValues])

  // 初始化数据
  useEffect(() => {
    // 初始化月份列表
    const arr = Array.from({ length: 31 }, (_, i) => ({
      title: `${i + 1}日`,
      value: i + 1,
    }))
    setMonthList(arr)

    console.log('initialValues', initialValues)
    console.log('formState22222222222222', formState)

    // 并行获取数据
    Promise.all([getEncTypeList(), getProxy(), getTaskGroup({ page: 1, limit: 10000 })])
      .then(([_, __, res]) => {
        const initialFormValues = {
          group_id:
            initialValues?.group_id ||
            res.data.groups.find(item => item.groupName === '常规任务')?.groupId,
          execute_priority: formState.priority || 3,
          execute_template_latest_case: formState.executeTemplateLatestCase,
          verification_mode_id: formState.verifyMode,
          name: initialValues?.name || '',
          execute_type: formState.executeType,
          execute_times: formState.executeTimes,
          execute_interval: initialValues?.execute_interval || 1,
          execute_unit: initialValues?.execute_unit || 'hour',
          execution_times: formState.executeTimesLimit,
          task_time: formState.taskTime,
          reduce_speed: formState.reduceSpeed,
          pool_id: initialValues.pool_id,
          encode: initialValues?.encode,
          enctype_ids: initialValues?.enctype_ids,
          site_ids: initialValues?.site_ids || [],
          device_ids: initialValues?.device_ids || [],
          attack_subject: initialValues?.attack_subject || 'random',
          scheduler_type: formState.schedulerType,
          day_of_week: formState.dayOfWeek,
          day_of_month: formState.dayOfMonth,
        }

        createForm.setFieldsValue(initialFormValues)
      })
      .catch(_ => {})
  }, [])

  // 监听Web应用选择变化
  useEffect(() => {
    const siteIds = createForm.getFieldValue('site_ids') || []
    setFormState(prev => ({ ...prev, webAppCount: siteIds.length }))

    if (siteIds.length === 1) {
      getSecurityDevice({ siteId: siteIds[0][1] })
        .then(res => setSecurityDeviceData(res.data.siteDeviceList))
        .catch(_ => {})
    }
  }, [createForm.getFieldValue('site_ids')])

  // 处理表单值变化
  const handleFormValueChange = (changedValues: any) => {
    if (changedValues.task_time) {
      const newTime = changedValues.task_time
      if (newTime && moment.isMoment(newTime) && newTime.isValid()) {
        isTimeUpdating.current = true
        taskTimeRef.current = newTime
        taskTimeMomentRef.current = newTime
        setFormState(prev => ({
          ...prev,
          ...changedValues,
          taskTime: newTime,
        }))
        isTimeUpdating.current = false
      } else {
        if (taskTimeMomentRef.current) {
          createForm.setFieldsValue({
            task_time: taskTimeMomentRef.current,
          })
        }
      }
    } else {
      const currentTime = taskTimeRef.current || formState.taskTime
      setFormState(prev => ({
        ...prev,
        ...changedValues,
        taskTime: currentTime,
      }))
      if (taskTimeMomentRef.current) {
        createForm.setFieldsValue({
          task_time: taskTimeMomentRef.current,
        })
      }
    }
  }

  // 处理执行类型变化
  const handleExecuteTypeChange = (value: number) => {
    // 如果切换到高频任务，且之前不是高频任务，则清空用例选择
    if (value === 4 && formState.executeType !== 4) {
      onTemplateStateChange?.({
        selectedTemplateIds: templateState?.selectedTemplateIds || [],
        selectedCaseIds: [],
        templateSwitchStates: templateState?.templateSwitchStates || {},
      })
    }

    // 保存当前时间值
    const currentTime = taskTimeRef.current || formState.taskTime
    const currentMomentTime = taskTimeMomentRef.current

    isTimeUpdating.current = true
    setFormState(prev => ({
      ...prev,
      executeType: value,
      schedulerType: value === 4 ? 'high_frequency_scheduler_type_daily' : 'scheduler_type_daily',
      taskTime: currentTime,
      executeTimesLimit: 0,
      dayOfWeek: [],
      dayOfMonth: [],
      executeTemplateLatestCase: value === 3 ? true : false,
      executionCycle: false,
    }))

    createForm.setFieldsValue({
      execute_type: value,
      task_time: currentMomentTime,
      scheduler_type: value === 4 ? 'high_frequency_scheduler_type_daily' : 'scheduler_type_daily',
      high_frequency_scheduler_type:
        value === 4 ? 'high_frequency_scheduler_type_daily' : undefined,
      execution_times: 0,
      day_of_week: [],
      day_of_month: [],
      execute_template_latest_case: value === 3 ? true : false,
      execution_cycle: false,
    })
    isTimeUpdating.current = false
  }

  // 处理执行模板最新用例变化
  const handleExecuteTemplateLatestCaseChange = (checked: boolean) => {
    setFormState(prev => ({ ...prev, executeTemplateLatestCase: checked }))
    createForm.setFieldsValue({ execute_template_latest_case: checked })
  }

  // 星期参数
  const [weekList] = useState([
    { title: t('周一'), value: 1 },
    { title: t('周二'), value: 2 },
    { title: t('周三'), value: 3 },
    { title: t('周四'), value: 4 },
    { title: t('周五'), value: 5 },
    { title: t('周六'), value: 6 },
    { title: t('周日'), value: 0 },
  ])

  // 站点选择
  const cascaderSiteListData = useMemo(() => {
    // 级联选择options数据处理
    let allChildren: { value: string; label: string }[] = []
    for (let i = 0; i < areaData.length; i++) {
      for (let j = 0; j < areaData[i].data?.length; j++) {
        if (areaData[i].data.length === 0) return
        allChildren.push({
          value: areaData[i].data[j]?.site_id,
          label: areaData[i].data[j]?.site_name
            ? areaData[i].data[j]?.site_name
            : areaData[i].data[j]?.site_url || areaData[i].data[j]?.site_id || t('未命名站点'),
        })
      }
    }

    let cascaderObj: any = []
    for (let i = 0; i < areaData.length; i++) {
      const childrenCount = areaData[i].data?.length || 0
      // 检查该分组下是否所有子项都是 offline 状态
      const allChildrenOffline =
        areaData[i].data?.every(child => child.alive_status === 'alive_status_offline') || false

      cascaderObj[i] = {
        value: areaData[i].id,
        label: (
          <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span>
              {areaData[i].name || areaData[i].site_name || areaData[i].id || t('未命名分组')}
            </span>
            {childrenCount > 0 && (
              <span style={{ color: '#4238C9', marginLeft: '8px' }}>({childrenCount})</span>
            )}
          </span>
        ),

        disabled: areaData[i].data ? allChildrenOffline : true,
        children:
          areaData[i].id == '-2'
            ? allChildren
            : areaData[i].data
                ?.sort((a, b) => {
                  if (
                    a.alive_status === 'alive_status_online' &&
                    b.alive_status !== 'alive_status_online'
                  ) {
                    return -1
                  }
                  if (
                    a.alive_status !== 'alive_status_online' &&
                    b.alive_status === 'alive_status_online'
                  ) {
                    return 1
                  }
                  return 0
                })
                .map(j => ({
                  value: j?.site_id,
                  disabled: j?.alive_status !== 'alive_status_online',
                  label: (
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <span>{j?.site_name || j?.site_url || j?.site_id || t('未命名站点')}</span>
                      <span style={{ flexShrink: 0 }}>
                        <Badge
                          style={{ marginLeft: 10 }}
                          status={j.alive_status === 'alive_status_online' ? 'success' : 'default'}
                        />

                        <Tooltip
                          title={
                            j.has_default_device ? '' : t('无安全设备，请对该资产关联默认验证设备')
                          }
                          getPopupContainer={() => document.body}
                          placement="topRight"
                          arrowPointAtCenter
                        >
                          <SvgIcon
                            name={j.has_default_device ? '设备' : '设备灰'}
                            style={{ width: 16, height: 16, marginLeft: 10 }}
                          />
                        </Tooltip>
                      </span>
                    </span>
                  ),

                  site: j,
                })),
      }
    }

    return areaData
      .map(v => {
        if (v.id === '-2') {
          return false
        } else if (v.data.length === 0) {
          return false
        } else {
          if (v.data) {
            const childrenCount = v.data.length
            // 检查该分组下是否所有子项都是 offline 状态
            const allChildrenOffline = v.data.every(
              child => child.alive_status === 'alive_status_offline',
            )

            return {
              value: v.name || v.site_name || v.id || t('未命名分组'),
              label: (
                <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <span>{v.name || v.site_name || v.id || t('未命名分组')}</span>
                  {childrenCount > 0 && (
                    <span style={{ color: '#4238C9', marginLeft: '8px' }}>({childrenCount})</span>
                  )}
                </span>
              ),

              disabled: allChildrenOffline, // 如果所有子项都是 offline，则禁用该分组
              children: v.data.map(child => ({
                value: child.site_id,
                disabled: child.alive_status !== 'alive_status_online',
                label: (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <span>
                      {child.site_name || child.site_url || child.site_id || t('未命名站点')}
                    </span>
                    <span style={{ flexShrink: 0 }}>
                      <Badge
                        style={{ marginLeft: 10 }}
                        status={
                          child.alive_status === 'alive_status_online' ? 'success' : 'default'
                        }
                      />

                      <Tooltip
                        title={
                          child.has_default_device
                            ? ''
                            : t('无安全设备，请对该资产关联默认验证设备')
                        }
                        getPopupContainer={() => document.body}
                        placement="topRight"
                        arrowPointAtCenter
                      >
                        <SvgIcon
                          name={child.has_default_device ? '设备' : '设备灰'}
                          style={{ width: 16, height: 16, marginLeft: 10 }}
                        />
                      </Tooltip>
                    </span>
                  </span>
                ),

                site: child,
              })),
            }
          } else {
            return {
              value: v.name || v.site_name || v.id || t('未命名分组'),
              label: v.name || v.site_name || v.id || t('未命名分组'),
            }
          }
        }
      })
      .filter(v => v.children)
  }, [areaData])

  console.log('cascaderSiteListData', cascaderSiteListData)

  // 递归提取所有 label 文本
  function extractLabelText(label: any): string {
    if (typeof label === 'string') return label
    if (React.isValidElement(label) && label.props) {
      const children = (label.props as { children?: any }).children
      if (typeof children === 'string') return children
      if (Array.isArray(children)) {
        return children.map(extractLabelText).join('')
      }
      if (children) return extractLabelText(children)
    }
    return ''
  }

  // 站点选择过滤
  const siteFilter = (inputValue: string, path: DefaultOptionType[]) => {
    const searchValue = inputValue.toLowerCase()
    return path.some(option => {
      const labelText = extractLabelText(option.label).toLowerCase()
      return labelText.includes(searchValue)
    })
  }

  // 关联安全设备过滤
  const deviceFilter = (inputValue: string, path: DefaultOptionType[]) => {
    const searchValue = inputValue.toLowerCase()
    return path.some(option => {
      const labelText = extractLabelText(option.label).toLowerCase()
      return labelText.includes(searchValue)
    })
  }

  // 自定义站点显示渲染函数
  const siteDisplayRender = (labels: string[], selectedOptions?: DefaultOptionType[]) => {
    if (!selectedOptions) return []

    return selectedOptions
      .map(option => {
        if (option?.site) {
          // 获取父级选项的名称
          const parentLabel = selectedOptions.find(opt =>
            opt.children?.some((child: any) => child.value === option.value),
          )?.value as string

          const siteName = option.site.site_name || option.site.site_url
          return parentLabel ? `${parentLabel} ${siteName}` : siteName
        }
        return null
      })
      .filter(Boolean)
      .join('、')
  }

  // 站点选择
  const cascaderDeviceListData = useMemo(
    () =>
      securityDeviceData.map(item => {
        const children = item.devices
          .sort((a, b) => {
            if (
              a.deviceStatus === 'DatasourceClientStatusOnline' &&
              b.deviceStatus !== 'DatasourceClientStatusOnline'
            ) {
              return -1
            }
            if (
              a.deviceStatus !== 'DatasourceClientStatusOnline' &&
              b.deviceStatus === 'DatasourceClientStatusOnline'
            ) {
              return 1
            }
            return 0
          })
          .map(device => ({
            value: device.deviceId,
            disabled:
              device.deviceStatus !== 'DatasourceClientStatusOnline' ||
              (selectedChainId !== null && device.chainId !== selectedChainId),
            label: (
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <span>
                  {device.deviceName
                    ? `${device.deviceName} (${device.deviceIp})`
                    : device.deviceIp}
                </span>
                <Badge
                  style={{ marginLeft: 10 }}
                  status={
                    device.deviceStatus === 'DatasourceClientStatusOnline' ? 'success' : 'default'
                  }
                />
              </span>
            ),

            device: {
              deviceId: device.deviceId,
              deviceName: device.deviceName,
              deviceIp: device.deviceIp,
              deviceStatus: device.deviceStatus,
              chainId: device.chainId,
            },
          }))

        return {
          value: item.deviceType,
          label: item.deviceType,
          children,
          selectable: false,
        }
      }),
    [securityDeviceData, selectedChainId],
  )

  // 自定义显示渲染函数
  const displayRender = (labels: string[], selectedOptions?: DefaultOptionType[]) => {
    if (!selectedOptions) return labels
    return selectedOptions.map((option, index) => {
      if (option?.device) {
        return option.device.deviceName
          ? `${option.device.deviceName} (${option.device.deviceIp})`
          : option.device.deviceIp
      }
      return labels[index]
    })
  }

  const siteSearchRender = (inputValue: string, path: DefaultOptionType[]) => {
    if (path.length === 0) return null
    const searchValue = inputValue.toLowerCase()
    return (
      <span>
        {path.map((option, idx) => {
          const labelText = extractLabelText(option.label)
          const lowerLabel = labelText.toLowerCase()
          const matchIdx = lowerLabel.indexOf(searchValue)
          if (matchIdx !== -1 && searchValue) {
            // 高亮匹配部分
            return (
              <span key={idx}>
                {labelText.slice(0, matchIdx)}
                <span style={{ color: '#4238c9', fontWeight: 600 }}>
                  {labelText.slice(matchIdx, matchIdx + searchValue.length)}
                </span>
                {labelText.slice(matchIdx + searchValue.length)}
                {idx < path.length - 1 ? ' / ' : ''}
              </span>
            )
          }
          return (
            <span key={idx}>
              {labelText}
              {idx < path.length - 1 ? ' / ' : ''}
            </span>
          )
        })}
      </span>
    )
  }

  return (
    <Container>
      <Form
        id="waf-create-config-form"
        onFinish={submitForm}
        form={createForm}
        layout="horizontal"
        colon={false}
        labelCol={{ flex: '75px', style: { textAlign: 'right' } }}
        onValuesChange={handleFormValueChange}
        initialValues={{
          verification_mode_id: formState.verifyMode,
          verify_mode: formState.verifyMode,
          execute_type: formState.executeType,
          execute_times: formState.executeTimes,
          attack_subject: 'random',
          execute_priority: formState.priority || 3,
          execute_template_latest_case: formState.executeTemplateLatestCase,
          reduce_speed: formState.reduceSpeed,
          pool_id: formState.poolId,
          task_time: formState.taskTime,
        }}
      >
        {/* 任务基本信息 */}
        <div className="section">
          <div className="section-title">
            {t('任务基本信息')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item
              label={t('任务名称')}
              name="name"
              required
              rules={[
                { required: true, message: t('请输入任务名称') },
                { max: 50, message: t('任务名称最多99字') },
                {
                  pattern: /^(?=.*\S).+$/,
                  message: t('任务名称不能全为空格'),
                },
              ]}
              className="form-item required"
            >
              <Input placeholder={t('请输入任务名称')} style={{ width: '300px' }} allowClear />
            </Form.Item>

            <Form.Item label={t('任务分组')} name="group_id" className="form-item">
              <Select placeholder={t('请选择任务分组')} style={{ width: 300 }} allowClear>
                {taskGroup?.map(item => (
                  <Select.Option key={item.groupId} value={item.groupId}>
                    {item.groupName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>

        {/* 任务验证配置 */}
        <div className="section">
          <div className="section-title">
            {t('任务验证配置')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item
              label={t('验证模式')}
              name="verification_mode_id"
              className="form-item"
              rules={[{ required: true, message: t('请选择验证模式') }]}
              style={{ marginLeft: 35 }}
            >
              <Checkbox.Group
                onChange={e => {
                  setFormState(prev => ({ ...prev, verifyMode: e as number[] }))
                  createForm.setFieldsValue({
                    verification_mode_id: e as number[],
                    site_ids: [],
                    device_ids: [],
                  })
                }}
                value={[2]}
                style={{ marginLeft: 10 }}
              >
                <Space>
                  <Checkbox value={2}>
                    {t('Web攻击机')}
                    <span style={{ color: '#A6A3D6' }}> → </span>
                    {t('Web应用')}
                  </Checkbox>
                  <Checkbox disabled value={1}>
                    {t('Web攻击机')}
                    <span style={{ color: '#A6A3D6' }}> → </span>
                    {t('Agent')}
                  </Checkbox>
                </Space>
              </Checkbox.Group>
            </Form.Item>

            {formState.verifyMode.includes(2) && (
              <div className="verify-config">
                <div className="config-title">
                  <span style={{ color: '#86909C', marginRight: 8 }}>{t('模式配置')}</span>
                  <span style={{ color: '#86909C' }}>{t('Web攻击机')}</span>
                  <span style={{ color: '#A6A3D6' }}> → </span>
                  <span style={{ color: '#86909C' }}>{t('Web应用')}</span>
                </div>
                <div className="config-form">
                  <Form.Item
                    label={<span style={{ color: '#333', fontWeight: 400 }}>{t('攻击主体')}</span>}
                    required
                    className="attack-subject-form-item"
                  >
                    <div className="flex-row">
                      <div className="label">{t('Web攻击机')}</div>
                      <Form.Item
                        name="attack_subject"
                        noStyle
                        rules={[{ required: true, message: t('请选择攻击主体') }]}
                      >
                        <Select placeholder={t('攻击机名称/IP')} style={{ width: 300 }} allowClear>
                          <Select.Option value="random">{t('随机分配')}</Select.Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </Form.Item>

                  <Form.Item
                    label={<span style={{ color: '#333', fontWeight: 400 }}>{t('目标主体')}</span>}
                    className="target-subject-form-item"
                    // name="site_ids"
                    required
                  >
                    <div className="flex-row">
                      <div className="label">{t('Web应用')}</div>
                      <Form.Item
                        noStyle
                        name="site_ids"
                        rules={[{ required: true, message: t('请选择目标主体') }]}
                      >
                        <Cascader
                          placeholder={t('Web应用')}
                          options={cascaderSiteListData}
                          showArrow
                          multiple
                          maxTagCount="responsive"
                          displayRender={siteDisplayRender}
                          showSearch={{
                            filter: siteFilter,
                            matchInputWidth: true,
                            render: siteSearchRender,
                            limit: 50,
                          }}
                          dropdownMenuColumnStyle={{ maxWidth: 520 }}
                          showCheckedStrategy={Cascader.SHOW_CHILD}
                          value={createForm.getFieldValue('site_ids') || []}
                          onChange={(value, selectedOptions) => {
                            // 只保留真实存在于 options 的值
                            function findInOptions(options, target) {
                              for (const opt of options) {
                                if (Array.isArray(target)) {
                                  if (opt.value === target[target.length - 1]) return true
                                  if (opt.children && findInOptions(opt.children, target))
                                    return true
                                }
                              }
                              return false
                            }
                            const validValues = value.filter(val =>
                              findInOptions(cascaderSiteListData, val),
                            )
                            createForm.setFieldsValue({ site_ids: validValues })
                            if (!validValues || validValues.length === 0) {
                              createForm.setFieldsValue({ device_ids: [] })
                              setSelectedChainId(null)
                              setSecurityDeviceData([])
                            }
                          }}
                        />
                      </Form.Item>
                      <Button
                        type="link"
                        onClick={() => {
                          window.open('/configure/site/resource', '_blank')
                        }}
                      >
                        {t('添加')}
                      </Button>
                    </div>
                  </Form.Item>

                  <Form.Item
                    label={<span style={{ color: '#333', fontWeight: 400 }}>{t('安全设备')}</span>}
                    // name="device_ids"
                    className="security-device-form-item"
                  >
                    <div className="flex-row">
                      <Form.Item noStyle name="device_ids">
                        <Cascader
                          placeholder={t('安全设备')}
                          options={cascaderDeviceListData}
                          multiple
                          showArrow
                          maxTagCount="responsive"
                          displayRender={displayRender}
                          showSearch={{
                            filter: deviceFilter,
                            matchInputWidth: true,
                            render: (inputValue, path) => {
                              if (path.length === 0) return inputValue
                              const searchValue = inputValue.toLowerCase()
                              return (
                                <span>
                                  {path.map((option, idx) => {
                                    const labelText = extractLabelText(option.label)
                                    const lowerLabel = labelText.toLowerCase()
                                    const matchIdx = lowerLabel.indexOf(searchValue)
                                    if (matchIdx !== -1 && searchValue) {
                                      return (
                                        <span key={idx}>
                                          {labelText.slice(0, matchIdx)}
                                          <span style={{ color: '#4238c9', fontWeight: 600 }}>
                                            {labelText.slice(
                                              matchIdx,
                                              matchIdx + searchValue.length,
                                            )}
                                          </span>
                                          {labelText.slice(matchIdx + searchValue.length)}
                                          {idx < path.length - 1 ? ' / ' : ''}
                                        </span>
                                      )
                                    }
                                    return (
                                      <span key={idx}>
                                        {labelText}
                                        {idx < path.length - 1 ? ' / ' : ''}
                                      </span>
                                    )
                                  })}
                                </span>
                              )
                            },
                            limit: 50,
                          }}
                          dropdownMenuColumnStyle={{ maxWidth: 520 }}
                          showCheckedStrategy={Cascader.SHOW_CHILD}
                          disabled={formState.webAppCount > 1}
                          onChange={value => {
                            if (value.length === 0) {
                              setSelectedChainId(null)
                            } else {
                              // 获取第一个选中设备的 chainId
                              const firstSelectedDevice = securityDeviceData
                                .flatMap(item => item.devices)
                                .find(device => device.deviceId === value[0][1])
                              if (firstSelectedDevice) {
                                setSelectedChainId(firstSelectedDevice.chainId)
                              }
                            }
                          }}
                        />
                      </Form.Item>
                      <Button
                        type="link"
                        onClick={() => {
                          window.open('/configure/device/access-management', '_blank')
                        }}
                      >
                        {t('添加接入设备')}
                      </Button>
                    </div>
                  </Form.Item>
                </div>
              </div>
            )}

            {formState.verifyMode.includes(1) && (
              <div className="verify-config">
                <div className="config-title">{t('模式配置 Web攻击机 → Agent')} </div>
                <div className="config-form">
                  <Form.Item label={t('攻击主体')} name="attack_subject_agent" required>
                    <div className="flex-row">
                      <div className="label">{t('Web攻击机')}</div>
                      <Select placeholder={t('攻击机名称/IP')} style={{ width: 300 }} />
                      <Button type="link">{t('添加')}</Button>
                    </div>
                  </Form.Item>

                  <Form.Item label={t('目标主体')} name="target_subject_agent" required>
                    <div className="flex-row">
                      <div className="label">Agent</div>
                      <Select
                        placeholder={t('Agent名称/IP')}
                        style={{ width: 300 }}
                        mode="tags"
                        tokenSeparators={[',']}
                      />

                      <Button type="link">{t('添加')}</Button>
                    </div>
                  </Form.Item>

                  <Form.Item label={t('安全设备')} name="security_device_agent">
                    <div className="flex-row">
                      <Select placeholder="HIDS/123456 (10.255.200.190)" style={{ width: 300 }} />
                      <Button
                        type="link"
                        onClick={() => {
                          window.open('/configure/device/access-management', '_blank')
                        }}
                      >
                        {t('添加接入设备')}
                      </Button>
                    </div>
                    <div className="device-list">
                      <div className="device-item">
                        <Radio checked>HIDS</Radio>
                        <span className="device-id">123456 (10.255.200.190)</span>
                        <span className="status-dot" />
                      </div>
                      <div className="device-item">
                        <Radio checked>EDR</Radio>
                        <span className="device-id">123456 (10.255.200.190)</span>
                        <span className="status-dot" />
                      </div>
                    </div>
                  </Form.Item>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 任务执行配置 */}
        <div className="section">
          <div className="section-title">
            {t('任务执行配置')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item
              label={t('执行类型')}
              name="execute_type"
              required
              className="form-item radio-box"
              style={{ marginLeft: 35 }}
            >
              <Radio.Group
                style={{
                  marginLeft: 8,
                }}
                onChange={e => {
                  handleExecuteTypeChange(e.target.value)
                  setFormState(prev => ({ ...prev, executionCycle: false }))
                }}
                value={formState.executeType}
              >
                <Radio.Button value={1}>{t('即时任务')}</Radio.Button>
                <Radio.Button value={2}>{t('定时任务')}</Radio.Button>
                <Radio.Button value={3}>{t('周期任务')}</Radio.Button>
                <Radio.Button value={4}>{t('高频任务')}</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <div>
              {formState.executeType === 2 && (
                <div className="execute-config">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 24,
                      marginLeft: 115,
                    }}
                  >
                    <Form.Item
                      name="task_time"
                      label={
                        <span style={{ fontWeight: 400, color: '#666' }}>{t('执行开始时间')}</span>
                      }
                      rules={[{ required: true, message: t('请选择执行开始时间') }]}
                    >
                      <DatePicker
                        placeholder={t('请选择日期与时间')}
                        style={{
                          width: '236px',
                          fontSize: '14px',
                          borderRadius: '6px',
                        }}
                        showTime
                        value={formState.taskTime}
                        onChange={value => {
                          setFormState(prev => ({ ...prev, taskTime: value }))
                        }}
                        disabledDate={disabledDate}
                        disabledTime={disabledDateTime}
                      />
                    </Form.Item>
                  </div>
                </div>
              )}
            </div>
            <div>
              {formState.executeType === 3 && (
                <div className="execute-config">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 24,
                      marginLeft: 115,
                    }}
                  >
                    <span
                      style={{ marginRight: 12, fontWeight: 400, color: '#666', marginLeft: 10 }}
                    >
                      {t('周期配置')}
                    </span>
                    <div>
                      <Input.Group compact style={{ display: 'flex' }}>
                        <Form.Item name="scheduler_type" noStyle>
                          <Select
                            style={{ width: '98px' }}
                            value={formState.schedulerType}
                            onChange={e => {
                              // 保存当前时间值
                              const currentTime = taskTimeRef.current || formState.taskTime
                              const currentMomentTime = taskTimeMomentRef.current

                              isTimeUpdating.current = true
                              setFormState(prev => ({
                                ...prev,
                                schedulerType: e,
                                taskTime: currentTime,
                              }))

                              // 确保时间值不被清空
                              if (currentMomentTime) {
                                createForm.setFieldsValue({
                                  task_time: currentMomentTime,
                                })
                              }
                              isTimeUpdating.current = false
                            }}
                          >
                            <Select.Option value="scheduler_type_daily">{t('每日')}</Select.Option>
                            <Select.Option value="scheduler_type_weekly">{t('每周')}</Select.Option>
                            <Select.Option value="scheduler_type_monthly">
                              {t('每月')}
                            </Select.Option>
                          </Select>
                        </Form.Item>
                        {formState.schedulerType === 'scheduler_type_daily' && (
                          <div
                            style={{
                              display: 'flex',
                              borderRadius: '0 6px 6px 0',
                              marginRight: 10,
                              alignItems: 'center',
                            }}
                          >
                            <Form.Item
                              name="task_time"
                              noStyle
                              rules={[{ required: true, message: t('请选择执行开始时间') }]}
                            >
                              <TimePicker
                                style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                value={formState.taskTime}
                                format="HH:mm:ss"
                                onChange={value => {
                                  if (value && value.isValid()) {
                                    isTimeUpdating.current = true
                                    taskTimeMomentRef.current = value
                                    taskTimeRef.current = value
                                    setFormState(prev => ({ ...prev, taskTime: value }))
                                    createForm.setFieldsValue({ task_time: value })
                                    isTimeUpdating.current = false
                                  } else {
                                    if (taskTimeMomentRef.current) {
                                      createForm.setFieldsValue({
                                        task_time: taskTimeMomentRef.current,
                                      })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </div>
                        )}
                        {formState.schedulerType === 'scheduler_type_weekly' && (
                          <Input.Group compact>
                            <div className="date-select">
                              <Form.Item
                                name="day_of_week"
                                noStyle
                                rules={[{ required: true, message: t('请选择星期') }]}
                              >
                                <TreeSelect
                                  showSearch={false}
                                  treeData={weekList}
                                  treeCheckable
                                  maxTagCount={1}
                                  showCheckedStrategy="SHOW_PARENT"
                                  style={{
                                    width: '120px',
                                    borderRadius: 'none',
                                    textAlign: 'left',
                                  }}
                                  placeholder={t('请选择星期')}
                                  value={formState.dayOfWeek}
                                  onChange={(week: string[]) => {
                                    setFormState(prev => ({
                                      ...prev,
                                      dayOfWeek: week,
                                      taskTime: taskTimeRef.current,
                                    }))
                                  }}
                                />
                              </Form.Item>
                            </div>
                            <Form.Item
                              name="task_time"
                              noStyle
                              rules={[{ required: true, message: t('请选择执行开始时间') }]}
                            >
                              <TimePicker
                                style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                value={formState.taskTime}
                                format="HH:mm:ss"
                                onChange={value => {
                                  if (value && value.isValid()) {
                                    isTimeUpdating.current = true
                                    taskTimeMomentRef.current = value
                                    taskTimeRef.current = value
                                    setFormState(prev => ({ ...prev, taskTime: value }))
                                    createForm.setFieldsValue({ task_time: value })
                                    isTimeUpdating.current = false
                                  } else {
                                    if (taskTimeMomentRef.current) {
                                      createForm.setFieldsValue({
                                        task_time: taskTimeMomentRef.current,
                                      })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </Input.Group>
                        )}
                        {formState.schedulerType === 'scheduler_type_monthly' && (
                          <Input.Group compact>
                            <div className="date-select" style={{ borderRadius: 'none' }}>
                              <Form.Item
                                name="day_of_month"
                                noStyle
                                rules={[{ required: true, message: t('请选择日期') }]}
                              >
                                <TreeSelect
                                  treeData={monthList}
                                  treeCheckable
                                  key="value"
                                  showCheckedStrategy="SHOW_PARENT"
                                  style={{ width: '120px' }}
                                  maxTagCount={1}
                                  value={formState.dayOfMonth}
                                  onChange={(e: any) => {
                                    setFormState(prev => ({
                                      ...prev,
                                      dayOfMonth: e,
                                      taskTime: taskTimeRef.current,
                                    }))
                                  }}
                                  placeholder={t('选择日期')}
                                />
                              </Form.Item>
                            </div>
                            <Form.Item
                              name="task_time"
                              noStyle
                              rules={[{ required: true, message: t('请选择执行开始时间') }]}
                            >
                              <TimePicker
                                style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                value={formState.taskTime}
                                format="HH:mm:ss"
                                onChange={value => {
                                  if (value && value.isValid()) {
                                    isTimeUpdating.current = true
                                    taskTimeMomentRef.current = value
                                    taskTimeRef.current = value
                                    setFormState(prev => ({ ...prev, taskTime: value }))
                                    createForm.setFieldsValue({ task_time: value })
                                    isTimeUpdating.current = false
                                  } else {
                                    if (taskTimeMomentRef.current) {
                                      createForm.setFieldsValue({
                                        task_time: taskTimeMomentRef.current,
                                      })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </Input.Group>
                        )}
                        <div style={{ width: 230 }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: 50, fontWeight: 400, color: '#666' }}>
                              {t('总执行')}
                            </div>
                            <Form.Item name="execution_times" noStyle>
                              <InputNumber
                                style={{ margin: '0 4px', width: '150px' }}
                                placeholder={t('默认不限次数')}
                                min={0}
                                max={999}
                                value={formState.executeTimesLimit}
                                onChange={val => {
                                  setFormState(prev => ({
                                    ...prev,
                                    executeTimesLimit: val || undefined,
                                  }))
                                }}
                              />
                            </Form.Item>
                            <span>{t('次')}</span>
                          </div>
                        </div>
                      </Input.Group>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="execute-config">
              {formState.executeType === 4 && (
                <>
                  <div className="flex-row">
                    <span style={{ marginLeft: 8, fontWeight: 400, color: '#666' }}>
                      {t('执行配置')}
                    </span>
                    <span style={{ fontWeight: 400, color: '#666' }}>{t('间隔')}</span>
                    <Form.Item
                      name="execute_interval"
                      noStyle
                      rules={[{ required: true, message: t('请输入间隔') }]}
                    >
                      <InputNumber
                        min={1}
                        max={24}
                        value={formState.executeTimes}
                        onChange={value =>
                          setFormState(prev => ({ ...prev, executeTimes: value || 1 }))
                        }
                      />
                    </Form.Item>
                    <Form.Item name="execute_unit" noStyle>
                      <Select defaultValue="hour" style={{ width: 80 }}>
                        <Select.Option value="hour">{t('小时')}</Select.Option>
                        <Select.Option value="minute">{t('分钟')}</Select.Option>
                      </Select>
                    </Form.Item>
                    <span style={{ fontWeight: 400, color: '#666' }}>{t('执行一次，持续')}</span>
                    <Form.Item name="high_frequency_execution_times" noStyle>
                      <InputNumber
                        min={0}
                        max={999}
                        placeholder={t('默认不限次数')}
                        style={{ width: 150 }}
                      />
                    </Form.Item>
                    <span style={{ fontWeight: 400, color: '#666' }}>{t('轮')}</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      name="execution_cycle"
                      label=""
                      style={{ marginLeft: 120, marginTop: 24 }}
                      valuePropName="checked"
                    >
                      <Checkbox
                        checked={formState.executionCycle}
                        onChange={e => {
                          const checked = e.target.checked
                          setFormState(prev => ({ ...prev, executionCycle: checked }))
                          createForm.setFieldsValue({ execution_cycle: checked })
                        }}
                      >
                        <span style={{ fontWeight: 400, color: '#666' }}>{t('周期执行')}</span>
                      </Checkbox>
                    </Form.Item>
                    {formState.executionCycle && (
                      <div>
                        <Input.Group compact style={{ display: 'flex' }}>
                          <Form.Item name="high_frequency_scheduler_type" noStyle>
                            <Select
                              style={{ width: '98px' }}
                              value={formState.schedulerType}
                              onChange={e => {
                                // 保存当前时间值
                                const currentTime = taskTimeRef.current || formState.taskTime
                                const currentMomentTime = taskTimeMomentRef.current

                                isTimeUpdating.current = true
                                setFormState(prev => ({
                                  ...prev,
                                  schedulerType: e,
                                  taskTime: currentTime,
                                }))

                                // 确保时间值不被清空
                                createForm.setFieldsValue({
                                  high_frequency_scheduler_type: e,
                                  high_frequency_time_of_day: currentMomentTime,
                                })
                                isTimeUpdating.current = false
                              }}
                            >
                              <Select.Option value="high_frequency_scheduler_type_daily">
                                {t('每日')}
                              </Select.Option>
                              <Select.Option value="high_frequency_scheduler_type_weekly">
                                {t('每周')}
                              </Select.Option>
                              <Select.Option value="high_frequency_scheduler_type_monthly">
                                {t('每月')}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                          {formState.schedulerType === 'high_frequency_scheduler_type_daily' && (
                            <div
                              style={{
                                display: 'flex',
                                borderRadius: '0 6px 6px 0',
                                marginRight: 10,
                                alignItems: 'center',
                              }}
                            >
                              <Form.Item
                                name="high_frequency_time_of_day"
                                noStyle
                                rules={[{ required: true, message: t('请选择执行开始时间') }]}
                              >
                                <TimePicker
                                  style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                  value={formState.taskTime}
                                  format="HH:mm:ss"
                                  onChange={value => {
                                    if (value && value.isValid()) {
                                      isTimeUpdating.current = true
                                      taskTimeMomentRef.current = value
                                      taskTimeRef.current = value
                                      setFormState(prev => ({ ...prev, taskTime: value }))
                                      createForm.setFieldsValue({
                                        high_frequency_time_of_day: value,
                                      })
                                      isTimeUpdating.current = false
                                    } else {
                                      if (taskTimeMomentRef.current) {
                                        createForm.setFieldsValue({
                                          high_frequency_time_of_day: taskTimeMomentRef.current,
                                        })
                                      }
                                    }
                                  }}
                                />
                              </Form.Item>
                            </div>
                          )}
                          {formState.schedulerType === 'high_frequency_scheduler_type_weekly' && (
                            <Input.Group compact>
                              <div className="date-select">
                                <Form.Item
                                  name="high_frequency_day_of_week"
                                  noStyle
                                  rules={[{ required: true, message: t('请选择星期') }]}
                                >
                                  <TreeSelect
                                    showSearch={false}
                                    treeData={weekList}
                                    treeCheckable
                                    maxTagCount={1}
                                    showCheckedStrategy="SHOW_PARENT"
                                    style={{
                                      width: '120px',
                                      borderRadius: 'none',
                                      textAlign: 'left',
                                    }}
                                    placeholder={t('请选择星期')}
                                    value={formState.dayOfWeek}
                                    onChange={(week: string[]) => {
                                      setFormState(prev => ({
                                        ...prev,
                                        dayOfWeek: week,
                                        taskTime: taskTimeRef.current,
                                      }))
                                    }}
                                  />
                                </Form.Item>
                              </div>
                              <Form.Item
                                name="high_frequency_time_of_day"
                                noStyle
                                rules={[{ required: true, message: t('请选择执行开始时间') }]}
                              >
                                <TimePicker
                                  style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                  value={formState.taskTime}
                                  format="HH:mm:ss"
                                  onChange={value => {
                                    if (value && value.isValid()) {
                                      isTimeUpdating.current = true
                                      taskTimeMomentRef.current = value
                                      taskTimeRef.current = value
                                      setFormState(prev => ({ ...prev, taskTime: value }))
                                      createForm.setFieldsValue({
                                        high_frequency_time_of_day: value,
                                      })
                                      isTimeUpdating.current = false
                                    } else {
                                      if (taskTimeMomentRef.current) {
                                        createForm.setFieldsValue({
                                          high_frequency_time_of_day: taskTimeMomentRef.current,
                                        })
                                      }
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Input.Group>
                          )}
                          {formState.schedulerType === 'high_frequency_scheduler_type_monthly' && (
                            <Input.Group compact>
                              <div className="date-select" style={{ borderRadius: 'none' }}>
                                <Form.Item
                                  name="high_frequency_day_of_month"
                                  noStyle
                                  rules={[{ required: true, message: t('请选择日期') }]}
                                >
                                  <TreeSelect
                                    treeData={monthList}
                                    treeCheckable
                                    key="value"
                                    showCheckedStrategy="SHOW_PARENT"
                                    style={{ width: '120px' }}
                                    maxTagCount={1}
                                    value={formState.dayOfMonth}
                                    onChange={(e: any) => {
                                      setFormState(prev => ({
                                        ...prev,
                                        dayOfMonth: e,
                                        taskTime: taskTimeRef.current,
                                      }))
                                    }}
                                    placeholder={t('选择日期')}
                                  />
                                </Form.Item>
                              </div>
                              <Form.Item
                                name="high_frequency_time_of_day"
                                noStyle
                                rules={[{ required: true, message: t('请选择执行开始时间') }]}
                              >
                                <TimePicker
                                  style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                  value={formState.taskTime}
                                  format="HH:mm:ss"
                                  onChange={value => {
                                    if (value && value.isValid()) {
                                      isTimeUpdating.current = true
                                      taskTimeMomentRef.current = value
                                      taskTimeRef.current = value
                                      setFormState(prev => ({ ...prev, taskTime: value }))
                                      createForm.setFieldsValue({
                                        high_frequency_time_of_day: value,
                                      })
                                      isTimeUpdating.current = false
                                    } else {
                                      if (taskTimeMomentRef.current) {
                                        createForm.setFieldsValue({
                                          high_frequency_time_of_day: taskTimeMomentRef.current,
                                        })
                                      }
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Input.Group>
                          )}
                          <div style={{ width: 230 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{ width: 80 }}>{t('总执行次数')}</div>
                              <Form.Item name="high_frequency_cycle_execution_times" noStyle>
                                <InputNumber
                                  style={{ margin: '0 4px', width: '150px' }}
                                  placeholder={t('默认不限次数')}
                                  min={0}
                                  max={999}
                                  value={formState.executeTimesLimit}
                                  onChange={val => {
                                    setFormState(prev => ({
                                      ...prev,
                                      executeTimesLimit: val || undefined,
                                    }))
                                  }}
                                />
                              </Form.Item>
                              <span>{t('次')}</span>
                            </div>
                          </div>
                        </Input.Group>
                      </div>
                    )}
                  </div>

                  <Form.Item
                    label={
                      <span style={{ fontWeight: 400, color: '#666' }}>{t('执行开始时间')}</span>
                    }
                    name="task_time"
                    style={{ marginTop: 6, marginLeft: 115 }}
                    rules={[{ required: true, message: t('请选择执行开始时间') }]}
                  >
                    <DatePicker
                      placeholder={t('请选择日期与时间')}
                      style={{
                        width: '100%',
                        fontSize: '14px',
                        borderRadius: '6px',
                      }}
                      showTime
                      value={formState.taskTime}
                      onChange={value => {
                        setFormState(prev => ({ ...prev, taskTime: value }))
                      }}
                      disabledDate={disabledDate}
                      disabledTime={disabledDateTime}
                    />
                  </Form.Item>
                </>
              )}

              <Form.Item label={t('执行速率')} name="reduce_speed" className="form-item">
                <InputNumber
                  min={1}
                  max={40}
                  value={formState.reduceSpeed}
                  onChange={value => {
                    setFormState(prev => ({ ...prev, reduceSpeed: value }))
                    createForm.setFieldsValue({ reduce_speed: value })
                  }}
                  style={{
                    marginLeft: 10,
                  }}
                />

                <span style={{ marginLeft: 17 }}>{t('个/秒')}</span>
              </Form.Item>
              <Form.Item
                label={
                  <div className="custom-label">
                    <span>{t('优先级')}</span>
                  </div>
                }
                name="priority"
                className="form-item"
                initialValue={3}
              >
                <Select
                  placeholder={t('请选择')}
                  style={{ width: 300, marginRight: 16, marginLeft: 10 }}
                  value={formState.priority}
                  onChange={value => {
                    setFormState(prev => ({ ...prev, priority: value }))
                    createForm.setFieldsValue({ priority: value })
                  }}
                >
                  <Select.Option value={1}>1</Select.Option>
                  <Select.Option value={2}>2</Select.Option>
                  <Select.Option value={3}>3</Select.Option>
                  <Select.Option value={4}>4</Select.Option>
                  <Select.Option value={5}>5</Select.Option>
                </Select>
                <Tooltip title={t('数字越大，优先级越高')}>
                  <SvgIcon name="提示" style={{ width: '14px', height: '14px', marginTop: 2 }} />
                </Tooltip>
              </Form.Item>
              {formState.executeType === 3 && (
                <Form.Item
                  label={t('执行增量')}
                  name="execute_template_latest_case"
                  className="execute-template-latest-case form-item"
                >
                  <Form.Item name="execute_template_latest_case" noStyle>
                    <BasSwitch
                      checked={formState.executeTemplateLatestCase}
                      onChange={handleExecuteTemplateLatestCaseChange}
                    />
                  </Form.Item>
                  <Tooltip
                    title={t('启用后则对全选用例的模版周期执行时执行新添加到模版中的用例')}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <SvgIcon
                      name="提示"
                      style={{ width: '14px', height: '14px', marginTop: 2, marginLeft: 10 }}
                    />
                  </Tooltip>
                </Form.Item>
              )}
            </div>
          </div>
        </div>

        {/* 任务高级配置 */}
        <div className="section">
          <div className="section-title">
            {t('任务高级配置')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item label={t('代理池')} name="pool_id" className="form-item">
              <div className="flex-row">
                <Select
                  placeholder={t('请选择')}
                  style={{ width: 300, marginLeft: 8 }}
                  allowClear
                  value={formState.poolId}
                  onChange={value => {
                    setFormState(prev => ({ ...prev, poolId: value }))
                    createForm.setFieldsValue({ pool_id: value })
                  }}
                >
                  {proxyData?.items?.map((item, i) => (
                    <Select.Option key={i} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
                <Button
                  type="link"
                  onClick={() => {
                    window.open('/configure/proxy/list', '_blank')
                  }}
                >
                  {t('添加代理池')}
                </Button>
              </div>
            </Form.Item>

            <div className="code" style={{ display: 'flex' }}>
              <Form.Item
                label={t('动态编码')}
                valuePropName="checked"
                name="encode"
                className="form-item"
              >
                <BasSwitch
                  onChange={value => setFormState(prev => ({ ...prev, encode: value }))}
                  checked={formState.encode}
                />
              </Form.Item>
              {formState.encode && (
                <Form.Item
                  label={<span style={{ color: '#666' }}>{t('编码类型')}</span>}
                  name="enctype_ids"
                  className="encoding-type-form-item"
                  rules={[{ required: true, message: t('请选择编码类型') }]}
                >
                  <Select
                    placeholder={t('请选择编码类型')}
                    mode="multiple"
                    showArrow
                    allowClear
                    maxTagCount={2}
                    style={{ width: 300 }}
                  >
                    {enTypeList.map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </div>
          </div>
        </div>
      </Form>
    </Container>
  )
}

const Container = styled.div`
  background: #fff;
  border-radius: 8px;
  .section {
    margin-bottom: 24px;
    padding: 0 16px;
    .section-title {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 88px;
        height: 6px;
        background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
        border-radius: 0px 86px 0px 100px;
        margin-top: 8px;
      }
      .section-bar {
        content: '';
        display: block;
        width: 100%;
        height: 4px;
        background: #ebeaf9;
        margin-top: 10px;
      }
    }

    .form-content {
      margin-top: 16px;
      .custom-label {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .form-item {
        margin-left: 35px;
      }
      .execute-config {
        border-radius: 8px;
        .flex-row {
          margin-left: 115px;
        }
        .execute-template-latest-case label {
          width: 70px;
          line-height: 20px;
          height: 40px;
        }
        .execute-template-latest-case {
          .ant-form-item-label {
            flex: 0 0 70px;
            white-space: normal;
            text-align: left;
            margin-right: 10px;
          }
          .ant-row {
            align-items: center;
          }
          .ant-form-item-control-input-content {
            display: flex;
            align-items: center;
            .ant-switch {
              margin-right: 5px;
            }
          }
        }
      }
      .verify-config {
        .flex-row {
          display: flex;
          align-items: center;
          gap: 6px;

          .label {
            width: 80px;
            color: #666;
            margin-left: 30px;
          }
        }
        .attack-subject-form-item {
          .ant-form-item-explain-error {
            margin-left: 125px;
          }
        }
        .security-device-form-item {
          label {
            margin-right: 12px;
          }
          .ant-select-in-form-item {
            width: 387px;
          }
          .ant-form-item-explain-error {
            margin-left: 135px;
          }
          .ant-cascader-menus .ant-cascader-menu:first-child .ant-cascader-checkbox {
            display: none !important;
          }
        }
        .target-subject-form-item {
          .ant-select-in-form-item {
            width: 300px;
          }
          .ant-form-item-explain-error {
            margin-left: 125px;
          }
        }
      }
      .radio-box {
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
          border-color: #d9d9d9;
          color: #4238c9;
          background: #e9e8f9;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          background: #d9d9d9;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
          box-shadow: none;
        }
      }
      .encoding-type-form-item {
        margin-left: 24px;
      }
    }

    .ant-form-item-label {
      font-weight: 500;
    }
  }
`

const FormItem = styled(Form.Item)`
  margin-bottom: 24px;
`
